import makeApiCall from "./axiosIndex";

const costCenterApis= {
    fetchCostCenter: (): Promise<any> => makeApiCall<any>({ method: 'get', url: '/seller/fetchCostCenter' }),
    deleteCostCenterById: (CostCenterId: string): Promise<any> => makeApiCall<any>({
        method: 'delete',
        url: `/seller/deleteCostCenterById`,
        params: { id: CostCenterId }
    }),
    createCostCenter: (data: any): Promise<any> => makeApiCall<any>({
        method: 'post',
        url: '/seller/createCostCenter',
        data
    }),
    updateCostCenterById: (id: any, data: any): Promise<any> => makeApiCall<any>({
        method: 'put',
        url: `/seller/updateCostCenterById`,
        params: { id: id },
        data
    }),
    fetchCostCenterById: (id: any): Promise<any> => makeApiCall<any>({
        method: 'get',
        url: `/seller/fetchCostCenterById`,
        params: { id }
    })
};

export default costCenterApis;